import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { CrudService } from "src/app/Services/crud.service";
import { LogedInUserService } from "src/app/Services/loged-in-user.service";
import { ROLE } from "../../Utils/const";
import { ActivatedRoute, Route, Router } from "@angular/router";

@Component({
  selector: "app-active-licenses",
  templateUrl: "./active-licenses.component.html",
  standalone: false,
  styles: [
    `
      thead._tas-custom-row th {
        background-color: #eff2f4 !important;
      }
    `,
  ],
})
export class ActiveLicensesComponent implements OnInit {
  data = [];
  isLoading: boolean = false;
  companyId;
  filter = {
    companyName: "",
    moduleName: "",
    moduleDisplayName: "",
    purchaseDate: "",
    validFrom: "",
    validUpto: "",
    transactionId: "",
  };
  sortField: string = "companyName";
  sortDirection: string = "asc";
  ROLE = ROLE;
  showLicenseManage = false;
  projectId;
  constructor(
    private crudService: CrudService,
    private translateService: TranslateService,
    private datePipe: DatePipe,
    private toastr: ToastrService,
    private logedInUserService: LogedInUserService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.translateService.setDefaultLang("en");
    let language = localStorage.getItem("language")
      ? localStorage.getItem("language")
      : "en";
    this.translateService.use(language);
    this.showLicenseManagement();
  }

  ngOnInit() {
    var self = this;
    self.logedInUserService.get(function (response) {
      if (response && response.companyId) {
        if (response.roleId) {
          const { Administrator = null } =
            ROLE.find((role) => role.Administrator) || {};
          const { ReadOnly = null } = ROLE.find((role) => role.ReadOnly) || {};

          if (
            Administrator &&
            ReadOnly &&
            !response.roleId.includes(Administrator)
          ) {
            self.onLogout();
          }
          if (Administrator && ReadOnly && response.roleId.includes(ReadOnly)) {
            self.onLogout();
          }
        }
        self.companyId = response.companyId;
        self.fetchData(response.companyId);
        // self.fetchProjectManagementData(response.companyId);
      }
    });

    this.projectId =
      this.route.snapshot.queryParamMap.get("projectManagementId") || "";
  }

  onLogout() {
    let self = this;
    self.crudService.post(
      { accessToken: localStorage.getItem("access_token") },
      function (response) {},
      "userManagements/logout?access_token=" +
        localStorage.getItem("access_token")
    );
    localStorage.removeItem("access_token");
    self.router.navigate(["/"]);
  }

  showLicenseManagement() {
    let self = this;
    self.logedInUserService.get(function (logedInUser) {
      const isSuperAdmin = logedInUser.roleId.some((id) => {
        return Object.values(self.ROLE[6])[0] === id.toString();
      });

      self.showLicenseManage = isSuperAdmin;
    });
  }

  fetchData(companyId) {
    var self = this;
    this.isLoading = true;
    const filterQuery = this.buildFilterQuery(companyId);
    self.crudService.get(
      null,
      function (response) {
        self.isLoading = false;
        if (response) {
          if (
            response.error &&
            response.error.error &&
            response.error.error.message
          ) {
            self.toastr.error(
              response.error.error.message,
              "Invalid Operation"
            );
          } else {
            if (response.length) {
              self.data = response;
            } else {
              self.data = [];
            }
          }
        }
      },
      `licenseHistories?filter[where][projectManagementId]=${this.projectId}&&filter[where][companyId]=${this.companyId}`
    );
  }

  buildFilterQuery(companyId) {
    let query = "";
    if (!this.showLicenseManage)
      query += `&filter[where][companyId]=${companyId}`;
    if (this.filter.companyName)
      query += `&filter[where][companyName][regexp]=/${this.filter.companyName}/i`;
    if (this.filter.transactionId)
      query += `&filter[where][transactionId][regexp]=/${this.filter.transactionId}/i`;
    if (this.filter.moduleName)
      query += `&filter[where][moduleName][regexp]=/${this.filter.moduleName}/i`;
    if (this.filter.moduleDisplayName)
      query += `&filter[where][moduleDisplayName][regexp]=/${this.filter.moduleDisplayName}/i`;
    if (this.filter.purchaseDate)
      query += `&filter[where][purchaseDate]=${this.datePipe.transform(
        this.filter.purchaseDate,
        "yyyy-MM-dd"
      )}`;
    if (this.filter.validFrom)
      query += `&filter[where][validFrom]=${this.datePipe.transform(
        this.filter.validFrom,
        "yyyy-MM-dd"
      )}`;
    if (this.filter.validUpto)
      query += `&filter[where][validUpto]=${this.datePipe.transform(
        this.filter.validUpto,
        "yyyy-MM-dd"
      )}`;
    return query;
  }

  applyFilter() {
    this.fetchData(this.companyId);
  }

  changeSort(field: string) {
    if (this.sortField === field) {
      this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
    } else {
      this.sortField = field;
      this.sortDirection = "asc";
    }
    this.fetchData(this.companyId);
  }
}
